export const environment = {
  production: true,
  firebase : {
    apiKey: 'AIzaSyACuVM4ljtaRoDjlhjAbo4-RT-rZmhrkRk',
    authDomain: 'ostobuddy-prod.firebaseapp.com',
    databaseURL: 'https://ostobuddy-prod.firebaseio.com',
    projectId: 'ostobuddy-prod',
    storageBucket: 'ostobuddy-prod.appspot.com',
    messagingSenderId: '456048841692',
    appId: '1:456048841692:web:8cc2336dc8085a4724f519'
  },
  changeUserEmail: 'https://us-central1-ostobuddy-prod.cloudfunctions.net/updateEmailAddress',
};
